import { CoreUtils } from "../core";
import { cc } from "../index";
export const WebsiteUtils = {
    url: (opts) => {
        return opts.domain ? `https://${opts.domain}` : `https://${opts.subdomain}.${cc.hosts.stores}`;
    },
    theme: {
        fromWebsite(w) {
            const headerFontFamily = w.font_heading.split(":")[0];
            const bodyFontFamily = w.font_body.split(":")[0];
            return {
                font: {
                    header: `'${headerFontFamily}', sans-serif;`,
                    body: `'${bodyFontFamily}',Verdana,Helvetica, sans-serif;`,
                    size: 16,
                },
                colors: {
                    primary: w.color_primary,
                    primary_text: w.color_primary_text,
                    text: w.color_text,
                    background: w.color_background,
                    border: CoreUtils.colors.shadeAlternate(0.16, w.color_background),
                    success: "#51a351",
                    warning: "#f89406",
                    error: "#bd362f",
                },
                status_colors: {
                    complete: "#51A351",
                    onroute: "#00BFFF",
                    ready: "#0080FF",
                    confirmed: "#B7D024",
                    unconfirmed: "#efbb1e",
                    cancelled: "#BD362F",
                },
                input: {
                    height: 38,
                    fontSize: 16,
                },
                breakpoints: CoreUtils.ui.breakpoints,
            };
        },
    },
    settings: {
        defaultTopNavLinkIds() {
            return ["about_us", "location", "contact_us", "order"];
        },
        defaultTopNavLinks() {
            return [
                {
                    _id: "about_us",
                    name: "About Us",
                    link: "",
                },
                {
                    _id: "location",
                    name: "Location",
                    link: "",
                },
                {
                    _id: "contact_us",
                    name: "Contact Us",
                    link: "",
                },
                {
                    _id: "order",
                    name: "Order Online",
                    link: "",
                },
            ];
        },
    },
};
export function companyPWAIsEnabled(pwa) {
    if (!pwa)
        return false;
    return (!!pwa.manifest_name &&
        !!pwa.manifest_short_name &&
        !!pwa.manifest_description &&
        !!pwa.image_icon &&
        !!pwa.manifest_bg_color &&
        !!pwa.manifest_theme_color);
}
//# sourceMappingURL=index.js.map